export const origin_tree = state => state.origin_tree;

export const version_list = state => state.version_list;

export const init_version_name = state => state.init_version_name;



// WEBPACK FOOTER //
// ./src/store/getters.js